import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "../Dashboard";
import { toast } from "sonner";
import { btn, card, errMsg, field, Provenance } from "./ui";

const EMPTY = { name: "", company: "", source: "human", detail: "" };

export default function StaffingDeals() {
    const [rows, setRows] = useState([]);
    const [form, setForm] = useState(EMPTY);
    const [busy, setBusy] = useState(false);

    const load = () => api.get("/ats-core/deals").then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e)));
    useEffect(() => { load(); }, []);

    const create = async (e) => {
        e.preventDefault();
        setBusy(true);
        try {
            await api.post("/ats-core/deals", form);
            setForm(EMPTY);
            toast.success("Deal geladen in Jeremai");
            await load();
        } catch (err) {
            toast.error(errMsg(err));
        } finally {
            setBusy(false);
        }
    };

    return (
        <PageHeader title="Deals" subtitle="Minimaal object: naam, bedrijf, bron, status. Agents en mensen schrijven naar dezelfde SoR.">
            <form onSubmit={create} className={`${card} grid md:grid-cols-2 gap-3 mb-6`} data-testid="deal-form">
                <input className={field} required placeholder="Naam" value={form.name} data-testid="deal-name"
                    onChange={(e) => setForm({ ...form, name: e.target.value })} />
                <input className={field} placeholder="Bedrijf" value={form.company} data-testid="deal-company"
                    onChange={(e) => setForm({ ...form, company: e.target.value })} />
                <select className={field} value={form.source} data-testid="deal-source"
                    onChange={(e) => setForm({ ...form, source: e.target.value })}>
                    {["human", "tender", "hris_opp", "other"].map((s) => <option key={s} value={s}>{s}</option>)}
                </select>
                <input className={field} placeholder="Detail" value={form.detail}
                    onChange={(e) => setForm({ ...form, detail: e.target.value })} />
                <button className={btn} disabled={busy} data-testid="deal-save">Deal aanmaken</button>
            </form>
            <div className="space-y-2" data-testid="deal-list">
                {rows.map((d) => (
                    <div key={d.id} className={`${card} flex flex-wrap items-center gap-3`} data-testid={`deal-row-${d.id}`}>
                        <div className="flex-1">
                            <div className="text-white">{d.name}</div>
                            <div className="text-xs text-[var(--jr-text-2)]">{d.company} · {d.source} · {d.status}</div>
                        </div>
                        <Provenance row={d} />
                    </div>
                ))}
                {!rows.length && <p className="text-sm text-[var(--jr-text-3)]">Nog geen deals.</p>}
            </div>
        </PageHeader>
    );
}
